var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab flex_v",class:{ selected: _vm.selected }},[_c('img',{attrs:{"src":_vm.img}}),_c('h5',{staticClass:"i_mt_1 i_md_2 i_mt_sm_1"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }